import { render, staticRenderFns } from "./referencia.vue?vue&type=template&id=7bec39cc"
import script from "./referencia.vue?vue&type=script&lang=js"
export * from "./referencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports